import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormSwitch,
  CInputGroup,
  CInputGroupText,
  CLoadingButton,
} from '@coreui/react-pro'
import React from 'react'
import Bootbox from 'bootbox-react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import PlayerService from 'src/service/PlayerService'
import { useEffect } from 'react'
import GeneralService from 'src/service/GeneralService'

const PlayerStructure = (props) => {
  useEffect(() => {
    PlayerService.getPlayerStructureInfo()
      .then((res) => {
        if (res.status === 200) {
          props.setPlayerStructureDetails(res.data)
        }
      })
      .then(() => {
        GeneralService.getUserGameInfo().then((res) => {
          if (res.status === 200) {
            if (res.data?.team_view == 0) {
              setLabelText('Switch to Position Free Selection Mode')
            }
            if (res.data?.team_view == 1) {
              setLabelText('Switch to Position Based Selection Mode')
            }
            setShowPosBased(res.data?.team_view)
            if (res.data?.team_view == 1) {
              setModalText(
                'Are you sure you want to set Position Free Selection Mode for the game?',
              )
            } else {
              setModalText(
                'Are you sure you want to set Position Based Selection Mode for the game?',
              )
            }
          }
        })
      })
  }, [])
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    min_gpa: Yup.number().min(1, 'Minimum value of 1 is required').required('Min GPA is required'),
    max_gpa: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max GPA is required'),

    min_gpb: Yup.number().min(1, 'Minimum value of 1 is required').required('Min GPB is required'),
    max_gpb: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max GPB is required'),
    min_gpc: Yup.number().min(1, 'Minimum value of 1 is required').required('Min GPC is required'),
    max_gpc: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max GPC is required'),
    min_gpd: Yup.number().min(1, 'Minimum value of 1 is required').required('Min GPD is required'),
    max_gpd: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max GPD is required'),
  })
  const formik = useFormik({
    initialValues: {
      min_gpa: props.playerStructuredetails?.min_gpa,
      max_gpa: props.playerStructuredetails?.max_gpa,
      min_gpb: props.playerStructuredetails?.min_gpb,
      max_gpb: props.playerStructuredetails?.max_gpb,
      min_gpc: props.playerStructuredetails?.min_gpc,
      max_gpc: props.playerStructuredetails?.max_gpc,
      min_gpd: props.playerStructuredetails?.min_gpd,
      max_gpd: props.playerStructuredetails?.max_gpd,
    },
    enableReinitialize: true,
    // validationSchema,
    onSubmit: (data) => {
      setLoader(true)
      PlayerService.savePlayerStructure(data)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            setLoader(false)
          }
        })
        .then(() => {
          data.addOnType = 'team_view'
          data.status = showPosBased
          GeneralService.changeUserGameAddOnStatus(data)
        })
    },
  })

  const [showPosBased, setShowPosBased] = useState(false)
  const [showPosConfirm, setShowPosConfirm] = useState(false)
  const [modalText, setModalText] = useState('')
  const [labelText, setLabelText] = useState('')

  const handlePosConfirm = () => {
    savePosFree()
    return setShowPosConfirm(false)
  }
  const handlePosCancel = () => {
    return setShowPosConfirm(false)
  }
  const handleChangeStatus = (event) => {
    if (event.target.checked === true) {
      setModalText('Are you sure you want to set Position Free Selection Mode for the game?')
    } else {
      setModalText('Are you sure you want to set Position Based Selection Mode for the game?')
    }
    setShowPosConfirm(true)
    setShowPosBased(event.target.checked)
  }

  const savePosFree = () => {
    const data = {}
    data.addOnType = 'team_view'
    data.status = showPosBased ? true : false
    GeneralService.changeUserGameAddOnStatus(data).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }
  return (
    <>
      <CCol xs={12}>
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <strong>
            <CFormSwitch
              size="lg"
              label={labelText}
              id="formSwitchCheckDefaultLg"
              checked={showPosBased ? true : false}
              onChange={handleChangeStatus}
              disabled={props.isTeamExists}
            />
          </strong>
          {!showPosBased && (
            <>
              <h6>Mode: Position Based Selection (Default)</h6>
              <CCol xs={12}>
                <ul>
                  <li>
                    In this mode, your game requires members to pick players based on the set player
                    limits for each position.
                  </li>
                  <li>You can set your own player selection limits for each position here.</li>
                  <li>
                    If no change is required, you can leave the default limits as currently set
                    below.
                  </li>
                </ul>
              </CCol>
            </>
          )}
          {showPosBased == 1 && (
            <>
              <h6>Mode: Position Free Selection Mode</h6>
              <CCol xs={12}>
                <ul>
                  <li>
                    In this mode, your game does not require members to pick players based on the
                    set player limits for each position.
                  </li>
                  <li>
                    There is no requirement for you to set player selection limits for each
                    position.
                  </li>
                  <li>
                    Members can select unlimited players from a certain position to pick their
                    fantasy team.
                  </li>
                  <li>This mode makes your game independent of position based restrictions.</li>
                </ul>
              </CCol>
            </>
          )}

          {!showPosBased && (
            <>
              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold w-23" style={{ width: '170px' }}>
                  Min GPA
                </CInputGroupText>
                <CFormInput
                  placeholder="Min GPA"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_gpa && formik.touched.min_gpa ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_gpa}
                  onChange={formik.handleChange}
                  aria-label="min_gpa"
                  id="min_gpa"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max GPA"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_gpa && formik.touched.max_gpa ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_gpa}
                  onChange={formik.handleChange}
                  aria-label="max_gpa"
                  id="max_gpa"
                />
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max GPA
                </CInputGroupText>
                {formik.errors.max_gpa && formik.touched.max_gpa && (
                  <CFormFeedback invalid>{formik.errors.max_gpa}</CFormFeedback>
                )}
                {formik.errors.max_gpa && formik.touched.max_gpa && (
                  <CFormFeedback invalid className="d-inline-block">
                    {formik.errors.max_gpa}
                  </CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Min GPB
                </CInputGroupText>
                <CFormInput
                  placeholder="Min GPB"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_gpb && formik.touched.min_gpb ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_gpb}
                  onChange={formik.handleChange}
                  aria-label="min_gpb"
                  id="min_gpb"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max GPB"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_gpb && formik.touched.max_gpb ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_gpb}
                  onChange={formik.handleChange}
                  aria-label="max_gpb"
                  id="max_gpb"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max GPB
                </CInputGroupText>
                {formik.errors.min_gpb && formik.touched.min_gpb && (
                  <CFormFeedback invalid>{formik.errors.min_gpb}</CFormFeedback>
                )}
                {formik.errors.max_gpb && formik.touched.max_gpb && (
                  <CFormFeedback invalid>{formik.errors.max_gpb}</CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold w-22" style={{ width: '170px' }}>
                  Min GPC
                </CInputGroupText>
                <CFormInput
                  placeholder="Min GPC"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_gpc && formik.touched.min_gpc ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_gpc}
                  onChange={formik.handleChange}
                  aria-label="min_gpc"
                  id="min_gpc"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max GPC"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_gpc && formik.touched.max_gpc ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_gpc}
                  onChange={formik.handleChange}
                  aria-label="max_gpc"
                  id="max_gpc"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max GPC
                </CInputGroupText>
                {formik.errors.min_gpc && formik.touched.min_gpc && (
                  <CFormFeedback invalid>{formik.errors.min_gpc}</CFormFeedback>
                )}
                {formik.errors.max_gpc && formik.touched.max_gpc && (
                  <CFormFeedback invalid>{formik.errors.max_gpc}</CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Min GPD
                </CInputGroupText>
                <CFormInput
                  placeholder="Min GPD"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_gpd && formik.touched.min_gpd ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_gpd}
                  onChange={formik.handleChange}
                  aria-label="min_gpd"
                  id="min_gpd"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max GPD"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_gpd && formik.touched.max_gpd ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_gpd}
                  onChange={formik.handleChange}
                  aria-label="max_gpd"
                  id="max_gpd"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max GPD
                </CInputGroupText>
                {formik.errors.min_gpd && formik.touched.min_gpd && (
                  <CFormFeedback invalid>{formik.errors.min_gpd}</CFormFeedback>
                )}
                {formik.errors.max_gpd && formik.touched.max_gpd && (
                  <CFormFeedback invalid>{formik.errors.max_gpd}</CFormFeedback>
                )}
              </CInputGroup>
              <CCol md={6}>
                <CLoadingButton
                  type="submit"
                  color="success"
                  variant="outline"
                  loading={loader}
                  disabled={props.isTeamExists}
                  id="submit"
                >
                  Submit
                </CLoadingButton>
              </CCol>
            </>
          )}
        </CForm>
      </CCol>
      <Bootbox
        show={showPosConfirm}
        type={'confirm'}
        message={modalText}
        onSuccess={handlePosConfirm}
        onCancel={handlePosCancel}
        onClose={handlePosCancel}
      />
    </>
  )
}

export default PlayerStructure
